import React from "react";

import config from "config/appConfig";

import { Navigate, Outlet, useLocation } from "react-router-dom";

import useJwt from "shared/services/api/core/jwt";

import type { AdminRoles } from "shared/types/Admin";
import type { UserRole } from "shared/types/UserModel";

interface SecureRouteProps {
	roles?: (AdminRoles | UserRole)[];
}

const SecureRoute = ({ roles = [] }: SecureRouteProps) => {
	const jwtService = useJwt();

	const { pathname, search } = useLocation();

	const hasJwt = jwtService.hasJwt();
	let isAllow = hasJwt;

	if (isAllow && roles?.length) {
		const { role } = jwtService.parseJwt();
		isAllow = roles.some(requiredRole => role === requiredRole);
	}

	if (!isAllow) {
		// URLSearchParams.set() already encodes values, no need for encodeURIComponent
		const query = new URLSearchParams();
		if (pathname && pathname !== "/") {
			query.set("redirectUrl", `${pathname}${search}`);
		}

		return (
			<Navigate
				to={{
					// pathname: hasJwt ? config.CORE_URLS.HOME : `${config.CORE_URLS.LOGIN}`,
					pathname: config.CORE_URLS.LAUNCH,
					search: query.toString()
				}}
				replace
			/>
		);
	}

	return <Outlet />;
};

export default SecureRoute;
